import React, { useRef } from "react";
import { Box } from "@mui/material";
import FormTextField from "../textField/formTextField";
import LaddaButton from "../buttons/laddaButton";
import ImagePreview, { resolveImagePreviewSource } from "./imagePreview";

const ImageUploadEvidence = ({ image, onImageChange, control, index, register, disabled = false, uploading = false }) => {
  const fileInputRef = useRef(null);
  const openFilePicker = () => { if (!disabled && !image.id) fileInputRef.current?.click(); };
  return <div>
    <ImagePreview source={resolveImagePreviewSource(image.preview)} busy={!!image.processing || uploading}
      disabled={disabled} onSelect={image.id ? undefined : openFilePicker} />
    <input type="file" accept="image/jpeg,image/png,image/gif" hidden ref={fileInputRef}
      onChange={async (event) => { const file = event.target.files?.[0]; event.target.value = ""; if (file) await onImageChange(file); }}
      disabled={disabled || !!image.id} />
    {!image.id && <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}>
      <LaddaButton type="button" disabled={disabled} loading={!!image.processing}
        onClick={openFilePicker}>{image.preview ? "Cambiar imagen" : "Agregar imagen"}</LaddaButton>
      {image.preview && <LaddaButton type="button" disabled={disabled} loading={false}
        backgroundColor="white" color="#6A6AD8" borderColor="#6A6AD8" onClick={() => onImageChange(null)}>Quitar selección</LaddaButton>}
    </Box>}
    <Box sx={{ mt: 1 }}>
      <p className="blueLabelForm">Descripción:</p>
      <FormTextField key={image.rowId + "-" + index} name={"descriptions." + index} control={control} register={register}
        isTextArea error={null} maxLength={150} rows={2} margin="0" disabled={!!image.id || disabled} />
    </Box>
  </div>;
};

export default ImageUploadEvidence;
